var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBids(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51109 8.33331L3.3586 14.515C3.19545 14.6769 3.06597 14.8695 2.97761 15.0816C2.88924 15.2938 2.84375 15.5214 2.84375 15.7512C2.84375 15.9811 2.88924 16.2086 2.97761 16.4208C3.06597 16.633 3.19545 16.8256 3.3586 16.9875C3.68807 17.3152 4.13389 17.4992 4.5986 17.4992C5.06331 17.4992 5.50912 17.3152 5.8386 16.9875L12.0111 10.8333M15.1003 12.7441L17.2553 10.5891C17.4115 10.4329 17.4992 10.2209 17.4992 9.99998C17.4992 9.77901 17.4115 9.56708 17.2553 9.41081L10.9336 3.08914C10.7773 2.93292 10.5654 2.84515 10.3444 2.84515C10.1235 2.84515 9.91154 2.93292 9.75526 3.08914L7.60026 5.24414C7.44404 5.40042 7.35627 5.61234 7.35627 5.83331C7.35627 6.05428 7.44404 6.2662 7.60026 6.42248L13.9219 12.7441C14.0782 12.9004 14.2901 12.9881 14.5111 12.9881C14.7321 12.9881 14.944 12.9004 15.1003 12.7441Z",
    stroke: "#125F64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBids);
export default __webpack_public_path__ + "static/media/bids.7714d58c33b95d0d510829b74126d662.svg";
export { ForwardRef as ReactComponent };